import { gql } from '@apollo/client';

export const UPDATE_WORK_ASSIGMENT_STATUS = gql`
	mutation batchWorkAssignmentStatusUpdate($statusUpdate: WorkAssignmentBatchStatusUpdateInput!) {
		batchWorkAssignmentsStatusUpdateV2(input: $statusUpdate) {
			__typename

			... on WorkAssignmentBatchMutationSuccessResponseV2 {
				workAssignmentSequences {
					sequenceGroupId
					rideId
					crewMember {
						id
						fullName
					}
					fromStation {
						id
						name
					}
					toStation {
						id
						name
					}
					fromTimestamp
					toTimestamp
					activityType
					status
					workAssignments {
						crewMember {
							id
							fullName
						}
						status
						version
						id
						fromStation {
							id
							name
						}
						toStation {
							id
							name
						}
					}
					run {
						name
						id
					}
					job {
						id
						code
						runId
					}
					extraActivities {
						fromTimestamp
						toTimestamp
						id
						version
						status
						fromStation {
							id
							code
						}
						toStation {
							id
							code
						}
						activityType
					}
				}
				adjacentWorkAssignmentsAffected
			}
			... on WorkAssignmentBatchMutationErrorResponse {
				errors {
					fromStationId
					toStationId
					errors
				}
			}
			... on WorkAssignmentOverlappingActivitiesResponse {
				overlappingActivities {
					fromTimestamp
					toTimestamp
					isCancellable
					activity {
						... on CrewMemberWorkAssignmentActivityItem {
							title
							rideId
							deadheadId
							activityType
							status
							fromStation {
								id
								name
								code
							}
							toStation {
								id
								name
								code
							}
							note
						}
						... on CrewMemberAbsenceActivityItem {
							reason {
								id
								name
							}
							note
						}
					}
				}
			}
		}
	}
`;
